import { getAnalytics, logEvent as _logEvent } from 'firebase/analytics';

let _analytics = null;

function getOrInit() {
	if (!_analytics) _analytics = getAnalytics();
	return _analytics;
}

export function logEvent(eventName, params) {
	_logEvent(getOrInit(), eventName, params);
}
